var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"show-more-btn",class:_vm.btn_class,attrs:{"to":_vm.path}},[_c('span',[_vm._v("Voir plus")]),_c('i',{staticClass:"mdi mdi-arrow-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }